import {
  GET_ADMIN_PAYMENT_TERMS,
  GET_ADMIN_PAYMENT_TERMS_SUCCESS,
  GET_ADMIN_PAYMENT_TERMS_ERROR,
  UPDATE_ADMIN_PAYMENT_TERM,
  UPDATE_ADMIN_PAYMENT_TERM_SUCCESS,
  UPDATE_ADMIN_PAYMENT_TERM_ERROR,
  POST_ADMIN_PAYMENT_TERM,
  POST_ADMIN_PAYMENT_TERM_SUCCESS,
  POST_ADMIN_PAYMENT_TERM_ERROR
} from "./actionTypes"

const INIT_STATE = {
  admin_payment_terms: [],
  error: null,
  loading: false,
}

const AdminPaymentTerms = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_PAYMENT_TERMS:
      return {
        ...state,
        loading: true
      }

    case GET_ADMIN_PAYMENT_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_payment_terms: action.payload
      }

    case GET_ADMIN_PAYMENT_TERMS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case POST_ADMIN_PAYMENT_TERM:
      return {
        ...state,
        loading: true
      }

    case POST_ADMIN_PAYMENT_TERM_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_payment_terms: [...state.admin_payment_terms, action.payload]
      }

    case POST_ADMIN_PAYMENT_TERM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case UPDATE_ADMIN_PAYMENT_TERM:
      return {
        ...state,
        loading: true
      }

    case UPDATE_ADMIN_PAYMENT_TERM_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_payment_terms: state.admin_payment_terms.map((item) => item.id === action.payload.id ? action.payload : item)
      }

    case UPDATE_ADMIN_PAYMENT_TERM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

export default AdminPaymentTerms
